import React, { FC, ReactElement, useMemo, useState } from 'react'
import { isUndefined } from 'lodash'
import { CommonTipItem } from './CommonTipItem'
import CloseIcon from '@mui/icons-material/Close'
import { AlertButtonClose, AlertCollapse } from './StyledComponents'

export const AlertTipItem: FC<{
  value: string | ReactElement
  iconComponent: ReactElement<HTMLElement, string> | null
  type?: 'warning' | 'primary' | 'success' | 'danger' | undefined
  isCloseButton?: boolean
  setIsOpenAlert?: (value: boolean) => void
  isOpenAlert?: boolean
  valueBold?: string
  valueWordUnderline?: string
  title?: string
}> = ({
  type,
  value,
  iconComponent,
  isCloseButton = false,
  setIsOpenAlert,
  isOpenAlert,
  valueBold,
  valueWordUnderline,
  title,
}) => {
  const [open, setOpen] = useState<boolean>(true)

  const setClasses = useMemo(() => {
    const typeAlert = !!type && type?.toLowerCase()
    switch (typeAlert) {
      case 'primary':
        return { borderColor: 'rgba(39, 110, 241, 0.2)' }
      case 'warning':
        return { borderColor: 'rgba(239, 40, 40, 0.2)' }
      case 'danger':
        return { borderColor: 'rgba(239, 128, 25, 0.2)' }
      case 'success':
        return { borderColor: 'rgba(25, 182, 97, 0.2)' }
      default:
        return { borderColor: 'rgba(39, 110, 241, 0.2)' }
    }
  }, [type])

  return (
    <AlertCollapse
      in={setIsOpenAlert || !isUndefined(isOpenAlert) ? isOpenAlert : open}
      sx={{
        ...(!isCloseButton && {
          '& > div': {
            padding: (theme) => theme.spacing(0.5, 1),
          },
          '& .MuiGrid-container': {
            alignItems: 'flex-start',
          },
        }),
        ...setClasses,
      }}
      data-test="alert"
    >
      <CommonTipItem
        value={value}
        iconComponent={iconComponent}
        valueBold={valueBold}
        valueWordUnderline={valueWordUnderline}
        title={title}
      />
      {isCloseButton && (
        <AlertButtonClose
          onClick={() => (setIsOpenAlert ? setIsOpenAlert(false) : setOpen(false))}
          data-test="closeAlert"
        >
          <CloseIcon />
        </AlertButtonClose>
      )}
    </AlertCollapse>
  )
}
